export default __webpack_public_path__ + "static/initiate_cloud-718130f60a60aeda58d7c55695b0f092.webp";